import { render } from "./FoodImageLoader.vue?vue&type=template&id=71926aeb"
import script from "./FoodImageLoader.vue?vue&type=script&lang=js"
export * from "./FoodImageLoader.vue?vue&type=script&lang=js"

import "./FoodImageLoader.vue?vue&type=style&index=0&id=71926aeb&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__